const Icon = ({ name, className = "" }) => {
    return <i className={`demo-icon ${name} ${className}`} />;
  };
  
  export default Icon;
  